import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {CtaButton} from '@optimaxdev/design-system';

import {useDispatch, useSelector} from 'react-redux';

import {TYP_CONTACT_LENSES} from 'constants/analytics/events/typ';
import {CL_RX_METHOD} from 'constants/success';
import {useGetCustomerData} from 'hooks/getCustomerData/getCustomerData';
import {useHostDispatch} from 'hooks/hostHooks/hostHooks';

import {getLabel} from 'libs/success/helpers/helpers';

import {setDrawerMethod, setDrawerState} from '../../../store/reducers/drawerPopup/drawerPopup';
import {getOrderLoading} from '../../../store/selectors/orderStatus/orderStatus';

/**
 * Render the button the visibly flow
 */
export const VisiblyButton: React.FC = () => {
    const isUserLoggedIn = useGetCustomerData()?.is_logged_in;

    const isDisabled = useSelector(getOrderLoading);
    const dispatchToHost = useHostDispatch();
    const dispatch = useDispatch();

    const handleOpenLogin = () => {
        dispatch(setDrawerMethod({rxMethod: CL_RX_METHOD.LOGIN}));
        dispatchToHost({
            payload: {
                disableRedirect: true,
                excludeAuthModal: true,
                tab: 'login',
                visible: true,
            },
            type: 'AUTH_POPUP@SET_VISIBLE',
        });
    };

    const startTest = () => {
        sendDesktopAnalyticsEvent(
            TYP_CONTACT_LENSES,
            `${getLabel(CL_RX_METHOD.EYE_EXAM)} - Start Vision Test`,
        );
        if (isUserLoggedIn) {
            dispatch(setDrawerMethod({rxMethod: CL_RX_METHOD.EYE_EXAM_ELIGIBILITY}));
            return;
        }
        sendDesktopAnalyticsEvent(
            TYP_CONTACT_LENSES,
            `${getLabel(CL_RX_METHOD.EYE_EXAM)} - Login Popup showed`,
            false,
        );

        dispatch(setDrawerState(false));
        setTimeout(handleOpenLogin, 500);
    };

    return (
        <CtaButton colorName="secondary" isDisabled={isDisabled} onClick={startTest}>
            Start Vision Test
        </CtaButton>
    );
};
